export const RequestUserToBookAMeetingDefinition = {
  ActionDefinitionId: 'Internal.RequestUserToBookAMeeting',
  FieldId_MeetingRequestedBy: '5eaaa0ce-73b7-4478-a431-bdedd8674232',
  FieldId_MeetingType: '8f6c5075-99d4-47f2-a459-e179feacabc2'
} as const;